/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Credentials_Validation_HintInputs */



/**
* | output |
* | --- |
* | "We'll verify your credentials against the upstream API before saving. Where supported, this does not consume credits." |
*
* @param {Integrations_Credentials_Validation_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_credentials_validation_hint = /** @type {((inputs?: Integrations_Credentials_Validation_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Credentials_Validation_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Zugangsdaten werden vor dem Speichern gegen die Upstream-API geprüft. Wo unterstützt, werden dabei keine Credits verbraucht.")
	return /** @type {LocalizedString} */ ("We'll verify your credentials against the upstream API before saving. Where supported, this does not consume credits.")
});